import { isFunction } from "lodash";
import React, { ReactNode } from "react";

export interface DraggableRowButtonsProps {
	absolute?: boolean;
	style?: any;
	children?: ReactNode;
}

const DraggableRowButtons: React.FC<DraggableRowButtonsProps> = ({ children, absolute = false, style }) => {
	return (
		<div className={`draggable-row-buttons ${absolute ? "pos-absolute" : ""}`} style={style}>
			{isFunction(children) ? children() : children}
		</div>
	);
};

export default DraggableRowButtons;
